import React, {
  useState,
  useRef,
  useMemo,
  useEffect,
  useCallback,
} from 'react';
import { Form } from '@unform/web';

import * as Yup from 'yup';

import { toast } from 'react-hot-toast';
import { AiOutlinePrinter } from 'react-icons/ai';
import {
  FaTimes,
} from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import FooterNF from '~/components/FooterNF';
import { useAuth } from '~/context/AuthContext';
import { Button as ButtonKit, Button } from 'ui-kit-takeat';
import formatCompleteDate from '~/services/formatCompleteDate';

import api from '~/services/api';
import getValidationErrors from '~/services/getValidationErrors';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import Input from 'components/Form/Input';

import {
  StatusTag,
  ModalPaymentBody,
  ActionsInside,
  InnerArea,
} from './styles';
import { IoDocumentTextOutline } from 'react-icons/io5';
import PaymentFormDelivery from 'components/Delivery/PaymentFormDelivery';
import { useMotoboys } from 'context/MotoboysContext';
import api2 from 'services/api2';

export default function DeliveryBill({
  session,
  getSessions
}) {
  const { user, paymentMethodsState } = useAuth();

  const [rescues, setRescues] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:rescues')) || []
  );

  useEffect(() => {
    localStorage.setItem('@gddashboard:rescues', JSON.stringify(rescues));
  }, [rescues]);

  // const [loading, setLoading] = useState(false);

  const [payments, setAllPayments] = useState(session?.payments);
  // const [hasOpenedBox, setHasOpenedBox] = useState(false);

  // const [creatingMotoboy, setCreatingMotoboy] = useState(false);

  const { motoboys } = useMotoboys();
  const [paymentsState, setPaymentsState] = useState([]);
  const [applyDiscount, setApplyDiscount] = useState(!!session.discount_total);
  const [discount, setDiscount] = useState(session.discount_total || '');
  const [discountObs, setDiscountObs] = useState(session.discount_obs || '');
  const [nfceRef, setNfceRef] = useState(session.nfce_ref || null);
  const [nfceAllowed, setNfceAllowed] = useState(session.nfce_allowed)
  const [discountObservation, setDiscountObservation] = useState(false);
  const [adminPassword, setAdminPassword] = useState(null);
  const [thisItemMotoboy, setThisItemMotoboy] = useState(session.motoboy);

  const getStatusFromSession = useCallback((sessionStatus) => {
    if (sessionStatus === 'open') {
      return {
        statusText: 'Aberta',
        color: '#17a2b8',
      };
    }
    if (sessionStatus === 'closing') {
      return {
        statusText: 'Fechando',
        color: '#17a2b8',
      };
    }
    if (sessionStatus === 'transfer') {
      return {
        statusText: 'Transferida',
        color: '#17a2b8',
      };
    }
    if (sessionStatus === 'finished') {
      return {
        statusText: 'Fechada',
        color: 'green',
      };
    }
    if (sessionStatus === 'finished2') {
      return {
        statusText: 'Fechada',
        color: '#dc3545',
      };
    }
    if (sessionStatus === 'completed') {
      return {
        statusText: 'Finalizada',
        color: '#dc3545',
      };
    }
    return {
      statusText: '',
      color: '#ddd',
    };
  }, []);

  const [status, setStatus] = useState(() => getStatusFromSession(session.status));

  const [modalEye, setModalEye] = useState(false);

  const [paid, setPaid] = useState(0);
  const [porcent, setPorcent] = useState(0);

  async function printClick(removeSelfSession) {
    try {
      await api.post('restaurants/printers/printer-queue', {
        table_session_id: session.id,
        close_after_print: true,
      });
      toast.success('Comanda impressa e fechada.');
    } catch (error) {
      toast.error('Erro ao imprimir e fechar comanda.');
    }
  }

  // async function printClickWithoutClose() {
  //   try {
  //     await api.post('restaurants/printers/printer-queue', {
  //       table_session_id: session.id,
  //       close_after_print: false,
  //     });
  //     toast.success('Comanda impressa.');
  //   } catch (error) {
  //     toast.error('Erro ao imprimir comanda.');
  //   }
  // }

  const [paymentsBill, setPaymentsBill] = useState();

  // async function handlePrintItem({ session_key }) {
  //   try {
  //     await api.put('restaurants/close-table-bill', {
  //       key: session_key,
  //     });
  //     getSessions();
  //     toast.success('Comanda fechada!');
  //   } catch (error) {
  //     toast.error('Não foi possível finalizar a comanda! tente novamente');
  //   }
  // }

  const handleItemFinished = useCallback(
    async (id = null, ref = null) => {
      try {
        setStatus({
          statusText: 'Finalizada',
          color: '#dc3545',
        });

        if (ref) {
          setNfceRef(ref);
          setNfceAllowed(true)
        }

        toast.success('Pedido entregue!');
      } catch (err) {
        toast.error('Não foi possível atualizar o pedido! tente novamente');
        console.log(err)
      }
    },
    []
  );

  const getPayments = useCallback(() => {
    let total = 0;

    paymentsBill &&
      paymentsBill.forEach((payment) => {
        total += parseFloat(payment.payment_value);
      });

    setPaid(total.toFixed(2).toString());

    const porcentPaid = session?.total_delivery_price > 0
      ? (total / session?.total_delivery_price) * 100
      : 100


    setPorcent(isNaN(porcentPaid) ? 0 : parseFloat(porcentPaid.toFixed(2)));
  }, [paymentsBill, session]);

  useEffect(() => {
    let total = 0;

    paymentsState &&
      paymentsState.forEach((payment) => {
        total += parseFloat(payment.value);
      });

    setPaid(total.toFixed(2).toString());

    const porcentPaid = session?.total_delivery_price > 0
      ? (total / session?.total_delivery_price) * 100
      : 100


    setPorcent(isNaN(porcentPaid) ? 0 : parseFloat(porcentPaid.toFixed(2)));

  }, [paymentsState])

  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);

  const cancelForm = useRef(null);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [modalCancelIsOpened, setModalCancelIsOpened] = useState(false);

  const toggleModalCancel = useCallback(() => {
    setModalCancelIsOpened(!modalCancelIsOpened);
  }, [modalCancelIsOpened]);

  const handleCancelBill = useCallback(
    async (data) => {
      setLoadingCancel(true);
      try {
        if (cancelForm?.current) {
          cancelForm.current.setErrors({});
        }

        let handleData = null;

        if (user?.order_cancel_password !== '') {
          const schema = Yup.object().shape({
            order_cancel_password: Yup.string().required('senha obrigatória'),
            cancel_reason: Yup.string().required('justicativa obrigatória'),
          });

          await schema.validate(data, {
            abortEarly: false,
          });

          handleData = {
            order_cancel_password: data.order_cancel_password,
            cancel_reason: data.cancel_reason,
          };
        }

        await api.delete(`restaurants/session/cancel/${session.id}`, {
          data: handleData,
        });

        toast.success('Comanda cancelada.');

        toggleModalCancel();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (cancelForm?.current) {
            cancelForm.current.setErrors(errors);
          }
        } else if (
          error.response.data.errorType === 'incorrect_order_cancel_password'
        ) {
          toast.error('Senha incorreta');
        } else {
          toast.error(`${error.response.data.message}`);
        }
      }
      setLoadingCancel(false);
    },
    [toggleModalCancel, session]
  );

  function onClickPrint(nfce) {
    const pageParams = {
      width: 795,
      height: 590,
      top: 100,
      left: 699,
      scrollbars: 'no',
      status: 'no',
      toolbar: 'no',
      location: 'no',
      menubar: 'no',
      resizable: 'no',
      fullscreen: 'no',
    };

    const paramsStr = Object.entries(pageParams)
      .map(([key, value]) => `${key}=${value}`)
      .join(', ');

    window.open(`${nfce.nfce_html}`, 'janela', paramsStr);
  }

  const getLastNf = useCallback(async () => {
    try {
      const response = await api.get(
        `/restaurants/fiscal/get-last-nf/${session.id}`
      );
      onClickPrint(response.data);
    } catch (error) {
      toast.error('Erro ao consultar NF');
    }
  }, [session]);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  // const handleUpdateMotoboy = async (data) => {
  //   if (data) {
  //     const id = data.id || data;
  //     try {
  //       await api2.post('/restaurants/motoboys/relate', {
  //         session_id: session.session_id,
  //         motoboy_id: id,
  //       });

  //       const updatedMotoboy = motoboys.find((m) => m.id === id);

  //       if (updatedMotoboy) {
  //         session.motoboy = updatedMotoboy;
  //         setThisItemMotoboy({
  //           value: updatedMotoboy.id,
  //           label: updatedMotoboy.name,
  //         });
  //       }

  //       toast.success('Motoboy atualizado com sucesso!');
  //     } catch (err) {
  //       console.log('Error handleUpdateMotoboy: ', err);
  //       toast.error('Erro ao atualizar motoboy');
  //     }
  //   } else {
  //     try {
  //       await api2.post('/restaurants/motoboys/relate', {
  //         session_id: session.session_id,
  //         motoboy_id: null,
  //       });

  //       setThisItemMotoboy({
  //         value: null,
  //         label: 'Retirar motoboy',
  //       });

  //       toast.success('Motoboy atualizado com sucesso!');
  //     } catch (err) {
  //       console.log('Error handleUpdateMotoboy: ', err);
  //       toast.error('Erro ao atualizar motoboy');
  //     }
  //   }
  // };

  const handleDiscountUpdate = useCallback(async () => {
    if (session?.discount_total !== discount && discount > 0) {
      try {
        const response = await api2.put(
          `/restaurants/delivery/orders/update/${session?.session_id}`,
          {
            discount: applyDiscount ? parseFloat(discount) : null,
            discount_obs: applyDiscount
              ? discountObservation
                ? `${discountObs} - ${discountObservation}`
                : discountObs
              : null,
            user_id: user.user_id,
            password: adminPassword,
          }
        );

      } catch (err) {
        console.log('Error handleDiscountUpdate: ', err);
      }
    }
  }, [
    discount,
    discountObs,
    applyDiscount,
    adminPassword,
    discountObservation,
  ]);

  const getSessionPayments = useCallback(async () => {

    const parsedData = payments.map((data) => ({
      id: data.id,
      value: data.payment_value,
      payment_method_id: data.payment_method_id,
      removable: data.removable,
      label: data.label,
      keyword: data.payment_method.keyword,
    }));

    setPaymentsState(parsedData);
  }, [session.id, payments]);

  useEffect(() => {
    getSessionPayments()
  }, [getSessionPayments]);


  useEffect(() => {
    try {
      getPayments();
    } catch (error) {
      toast.error('Erro ao carregar informações');
    }
  }, [getPayments]);

  const toggleEye = useCallback(() => {
    setModalEye(!modalEye);
  }, [modalEye]);

  useEffect(() => {
    const payments_bill = payments;

    setPaymentsBill(payments_bill);
  }, [session, payments]);

  const [allPaymentMethods, setAllPaymentMethods] = useState([]);
  const [favoritePaymentMethods, setFavoritePaymentMethods] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const getPaymentMethods = useCallback(async () => {
    const methods = paymentMethodsState;

    methods.sort((a, b) => Number(b.is_favorite) - Number(a.is_favorite));

    setAllPaymentMethods([...methods]);

    const favoriteMethods = methods.slice(0, 8);

    setFavoritePaymentMethods(favoriteMethods);

    setPaymentMethods(methods.slice(8));
  }, [paymentMethodsState]);

  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);



  return (
    <>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <tr>
        <td>
          {session?.sales_channel}
        </td>
        <td>
          {(session.status === 'finished' || session.status === 'delivered')
            ? formatCompleteDate(session.end_time)
            : formatCompleteDate(session.start_time)}
        </td>

        <td>#{session.id}</td>

        <td>
          R$ {session.total_delivery_price}
        </td>
        <td>
          R$
          {paid.toLocaleString('pt-br', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          <StatusTag color={porcent >= 100 ? '#3BD2C1' : '#FF2C3D'}>
            <span>
              {status.statusText} {porcent}%
            </span>
          </StatusTag>
        </td>

        <td>{nfceAllowed ? `#${nfceRef}` : '-'}</td>

        <td style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ActionsInside>
            {user.is_printed_on_web || user.print_bills_on_web ? (
              <ButtonKit
                title="Imprimir"
                buttonColor="#2EC9B7"
                inverted
                icon={<AiOutlinePrinter />}
                style={{ border: 'none', background: '#F4F4F4' }}
                onClick={() => {
                  handleFetchDataToPrint({
                    print_type: 'table_session',
                    table_session_id: session.id,
                    is_delivery: true,
                  });
                }}
              />
            ) : (
              <ButtonKit
                title="Imprimir"
                buttonColor="#2EC9B7"
                inverted
                icon={<AiOutlinePrinter />}
                style={{ border: 'none', background: '#F4F4F4' }}
                onClick={() => printClick(false)}
              />
            )}
            {nfceAllowed ? (
              <>
                <ButtonKit
                  title="Imprimir NF"
                  buttonColor="66cfff"
                  inverted
                  icon={<IoDocumentTextOutline />}
                  style={{
                    order: 'none',
                    background: '#F4F4F4',
                    border: 'none',
                  }}
                  onClick={getLastNf}
                />
              </>
            ) : <ButtonKit
              title="Emitir NF"
              buttonColor="66cfff"
              inverted
              icon={<IoDocumentTextOutline />}
              style={{
                order: 'none',
                background: '#F4F4F4',
                border: 'none',
              }}
              onClick={toggleEye}
            />
            }
            <ButtonKit
              title="Cancelar"
              buttonColor="#FF3A2C"
              inverted
              icon={<FaTimes />}
              style={{ border: 'none', background: '#F4F4F4' }}
              onClick={toggleModalCancel}
            />

            {/* modal de cancelamento de balcao */}
            <Modal isOpen={modalCancelIsOpened} toggle={toggleModalCancel}>
              <Form onSubmit={handleCancelBill} ref={cancelForm}>
                <ModalBody>
                  <h4>
                    <b>Tem certeza que deseja cancelar esse pedido?</b>
                  </h4>
                  <p>
                    Os <b>pagamentos</b> inseridos serão deletados{' '}
                    {session.nfce_allowed && (
                      <>
                        e a <b>nota fiscal</b> será cancelada se estiver dentro do
                        período elegível para cancelamento.
                      </>
                    )}
                  </p>
                  {user?.order_cancel_password !== '' && (
                    <div style={{ borderTop: '1px solid #D9D9D9', marginTop: 5 }}>
                      <Input
                        name="order_cancel_password"
                        label="Senha de cancelamento"
                        type="password"
                      />
                      <Input name="cancel_reason" label="Justificativa" />
                    </div>
                  )}
                </ModalBody>
                <ModalFooter style={{ float: 'right' }}>
                  <Button
                    title="Cancelar pedido"
                    type="submit"
                    disabled={loadingCancel}
                  />
                </ModalFooter>
              </Form>
            </Modal>

            <Modal isOpen={modalEye} toggle={toggleEye}>
              <InnerArea browserZoomLevel={browserZoomLevel}>
                <ModalPaymentBody>
                  <PaymentFormDelivery
                    item={session}
                    payments_session={paymentsState}
                    setPaymentsState={setPaymentsState}
                    discount={discount}
                    discountObs={discountObs}
                    setDiscount={setDiscount}
                    setDiscountObs={setDiscountObs}
                    setDiscountObservation={setDiscountObservation}
                    applyDiscount={applyDiscount}
                    setApplyDiscount={setApplyDiscount}
                    adminPassword={adminPassword}
                    setAdminPassword={setAdminPassword}
                    paymentMethods={paymentMethods}
                    allPaymentMethods={allPaymentMethods}
                    favoritePaymentMethods={favoritePaymentMethods}
                  />
                </ModalPaymentBody>

                {/* {motoboysOptions &&
                  motoboysOptions.length > 0 &&
                  !item.ifood_on_demand_id && (
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'flex-end',
                        gap: '15px',
                      }}
                    >
                      <DefaultSelect
                        options={motoboysOptions}
                        placeholder="Motoboy"
                        name="motoboy"
                        label="Motoboy"
                        value={thisItemMotoboy}
                        onChange={(e) => handleUpdateMotoboy(e.value)}
                      />
                      <ActionButton
                        buttonColor="#2ec9b7"
                        icon={<FaPlus />}
                        minWidth={40}
                        onClick={() => setCreatingMotoboy(true)}
                      />
                    </div>
                  )} */}

                {/* <Modal isOpen={creatingMotoboy}>
                  <CreateMotoboy
                    toggleModalRegisterMotoboy={() => setCreatingMotoboy(false)}
                    motoboyCreated={(data) => {
                      console.log('motoboy created data > ', data);
                      handleUpdateMotoboy(data);
                      setThisItemMotoboy({ value: data.id, label: data.name });
                      setCreatingMotoboy(false);
                    }}
                  />
                </Modal> */}

                <FooterNF
                  session={session}
                  toggleEye={toggleEye}
                  getSessions={() => { }}
                  payments={paymentsState}
                  has_nfce={user.has_nfce}
                  item={session}
                  handleItemFinished={handleItemFinished}
                  motoboys={motoboys}
                  handleDiscountUpdate={handleDiscountUpdate}
                  discount={discount}
                  discountObs={discountObs}
                  applyDiscount={applyDiscount}
                  adminPassword={adminPassword}
                  user={user}
                />
              </InnerArea>
            </Modal>

          </ActionsInside>
        </td>
      </tr>
    </>
  );
}
